import dayjs, { Dayjs } from "dayjs";
import {
  ICaseInformation,
  ICaseInformationModel,
} from "us.collection.case/reducers/CaseInformation/Interfaces";
import { DateFormats } from "../Constants";

export const getFormikCaseInfo = (
  caseInfo: ICaseInformationModel
): ICaseInformation | {} => {
  return caseInfo.data
    ? {
        ...caseInfo.data,
        debtwarningDate:getValidDate(caseInfo.data.debtwarningDate),
        boDate:getValidDate(caseInfo.data.boDate),
        dcfDate:getValidDate(caseInfo.data.dcfDate),
        vtDate:getValidDate(caseInfo.data.vtDate),
        lastBODate:getValidDate(caseInfo.data.lastBODate),
        lastDistraintDate:getValidDate(caseInfo.data.lastDistraintDate),
        lastCourtDate:getValidDate(caseInfo.data.lastCourtDate),
        migratedDate:getValidDate(caseInfo.data.migratedDate),
        objectionDate:getValidDate(caseInfo.data.objectionDate),
        obsoleteDate:getValidDate(caseInfo.data.obsoleteDate),
        interestStopDate:getValidDate(caseInfo.data.interestStopDate),
        closeDate:getValidDate(caseInfo.data.closeDate),
        nextDueDate:getValidDate(caseInfo.data.nextDueDate),
        caseDueDate:getValidDate(caseInfo.data.caseDueDate),
        isDWUpdated: false,
        isPopConfirmVisible: false
      }
    : {};
};

export const getValidDate = (dateString:string):Dayjs|undefined =>{
  return dayjs(dateString, DateFormats.StandardDateFromat).isValid()
  ?dayjs(dateString, DateFormats.StandardDateFromat)
  :undefined
}

export const getValidDateStandardString = (date:Dayjs):string =>{
  return dayjs(date).isValid()
  ?dayjs(date).format(DateFormats.StandardDateFromat)
  :''
}
